// Quick Buy Manager
// Handles initialization and management of all quick-buy panels

document.addEventListener('DOMContentLoaded', () => {
    // Ensure portal container exists
    const portalContainer = document.getElementById('quick-buy-portal');
    if (!portalContainer) return;

    // Find all quick-buy panels in the document that are NOT in the portal
    const quickBuyPanels = Array.from(document.querySelectorAll('[id^="quick-buy-"]'))
      .filter(panel => !panel.closest('#quick-buy-portal'));

    quickBuyPanels.forEach(panel => {
      const panelId = panel.id;
      // Check if this quick-buy already exists in the portal
      if (!document.querySelector(`#quick-buy-portal #${panelId}`)) {
        portalContainer.appendChild(panel.cloneNode(true));
      }
      panel.remove();
    });
});
